import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AllTableColumn } from '@prlw/core/monitor/types/all-table';
import { AllInstruments } from '@prlw/core/monitor/all-instruments.entity';
import { Destination } from '@prlw/core/destinations/destination.entity';
import { Modifier } from '@prlw/core/monitor/types/common';

@Component({
  selector: 'prlw-all-table-column-content',
  templateUrl: './column-content.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableColumnContentContainer {
  @Input() public column!: AllTableColumn;
  @Input() public instrument!: AllInstruments;
  @Input() public modifiers: Modifier | null = null;
  @Input() public destination: Destination | null = null;
}
